import { useCallback, useState } from 'react';
import ContainerTab from '../../components/Admin/ContainerTab';
import Sidebar from '../../components/Admin/Sidebar';

const Admin = () => {
    const [currentTab, setCurrentTab] = useState<number>(1);
    const handleShowTab = useCallback((value: number) => {
        setCurrentTab(value);
    }, [])
    return (
        <div className="flex h-full bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900">
            <Sidebar onCurrentTab={handleShowTab} tab={currentTab} />
            <ContainerTab currentTab={currentTab} />
        </div>
    );
};

export default Admin;